import {useState, useCallback, type ReactNode} from 'react'

import {TooltipBubble, TooltipWrapper} from './Tooltip.styled'

import {Typography} from '~/components/general/typography/Typography'

export type TooltipProps = {
  content: ReactNode
  children: ReactNode
  placement?: 'top' | 'bottom' | 'left' | 'right'
  align?: 'start' | 'center' | 'end'
  inline?: boolean
  maxWidth?: number
  nowrap?: boolean
}

export const Tooltip = ({
  content,
  children,
  placement = 'top',
  align = 'center',
  inline = true,
  maxWidth,
  nowrap = false,
}: TooltipProps) => {
  // Hover state kept for potential future logic (e.g., delay); CSS controls visibility.
  const [, setHover] = useState(false)
  const onEnter = useCallback(() => setHover(true), [])
  const onLeave = useCallback(() => setHover(false), [])

  return (
    <TooltipWrapper
      $inline={inline}
      onMouseEnter={onEnter}
      onMouseLeave={onLeave}>
      {children}
      <TooltipBubble
        $placement={placement}
        $align={align}
        $maxWidth={maxWidth}
        $nowrap={nowrap}>
        {typeof content === 'string' ? (
          <Typography size="sm" color="#fff">
            {content}
          </Typography>
        ) : (
          content
        )}
      </TooltipBubble>
    </TooltipWrapper>
  )
}
